import { useSite } from "@/context/SiteContext";
import { fmtTime } from "@/lib/format";
import { hoursSummary } from "@/lib/contact";

export const HoursList = ({ compact = false, className = "" }) => {
  const { settings } = useSite();
  const schedule = settings.schedule || [];
  const uniform = schedule.every((d) => d.open && d.start === schedule[0]?.start && d.end === schedule[0]?.end);
  if (compact || uniform) {
    return (
      <p className={className} data-testid="clinic-hours">
        {hoursSummary(schedule)}
        {settings.hours_note ? ` · ${settings.hours_note}` : ""}
      </p>
    );
  }
  return (
    <ul className={`space-y-1 ${className}`} data-testid="clinic-hours">
      {schedule.map((d) => (
        <li key={d.day} className="flex justify-between gap-6">
          <span>{d.day}</span>
          <span className="font-medium">{d.open ? `${fmtTime(d.start)} – ${fmtTime(d.end)}` : "Closed"}</span>
        </li>
      ))}
      {settings.hours_note && <li className="pt-1 text-sm">{settings.hours_note}</li>}
    </ul>
  );
};
